const axios = require('axios')

const viacep = axios.create({
  baseURL: `https://viacep.com.br/ws`,
  timeout: 7000,
  headers: { 'Content-Type': 'application/json' }
})

export default viacep



// WEBPACK FOOTER //
// ./src/services/viacep.js